import React, { Suspense, useEffect, useState } from 'react'
import classes from "./VirtualSources.module.css";
import { checkSiteConfig, clearDeviceLogs, getCamectsAPI, getDavantisesAPI, getIntegrations, getLiveViewCameras, getSchedules, getSigFoxSensorsAPI, getTankSensorsForSite, getVirtualRelationshipsAPI, listPartneredArcs } from '../../../../../Api Methods/Api';
import { useDispatch, useSelector } from 'react-redux';
import VirtualSourcesGrid from '../../../../GridList/VirtualSourcesGrid';
import CamectModalForm from './Camect/CamectModalForm';
import SigfoxModalForm from './Sigfox/SigfoxModalForm';
import { Await } from 'react-router-dom';
import Oval from 'react-loading-icons/dist/esm/components/oval';
import DeviceCardSkeleton from '../../../Cards/Devices/DeviceCardSkeleton';
import GatewayModalForm from './Gateway/GatewayModalForm';
import LockModalForm from './SmartLocks/LockModalForm';
import SelectCCTVIntegration from './SelectCCTVIntegration';
import AiboxForm from './Aibox/AiboxForm'
import HikvisionForm from './Hikvision/hikvisionForm';
import LiveViewCameraForm from './LiveView/LiveViewCameraForm';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';

import successAnim from '../../../../../assets/animations/success.json'
import failAnim from '../../../../../assets/animations/fail.json'
import areYouSure from '../../../../../assets/animations/areYouSure.json'
import { Button } from 'primereact/button';
import AjaxForm from './Ajax/AjaxForm';
import DahuaForm from './Dahua/DahuaForm';
import NBIOTSensorForm from './NBIOTSensor/NBIOTSensorForm';
import BLESensorForm from './BLESensor/BLESensorForm';
import SelectSensor from './SelectSensor';
import FloodSensorForm from './FloodSensor/FloodSensorForm';
import TankSensorForm from './TankSensor/TankSensorForm';
import WebeyeForm from './Webeye/WebeyeForm';


const VirtualSources = ({ iglooLocks, outputs, inputs, deviceData, setHasDeviceChanged, DeviceDetails, apiData, device, preloadedData, siteGroupID, isRESUREGroup }) => {
    const firmware = device[1].firmware.split('.')
    const firmwareMajor = firmware[0]
    const firmwareMinor = firmware[1]
    const firmwareRevision = firmware[2]
    const siteType = device[1].type
    let DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const dispatch = useDispatch();
    const [_supportsCamect, _setSupportsCamect] = useState(0)
    const [monitoredByName, setMonitoredByName] = useState(null)
    const [sigfoxSensors, setSigfoxSensors] = useState(null);
    const [efentoSensors, setEfentoSensors] = useState(null);
    const [tankSensors, setTankSensors] = useState(null);
    const [teltonikaSensors, setTeltonikaSensors] = useState(null);
    const [integrations, setIntegrations] = useState(null);
    const [gateways, setGateways] = useState(null);
    const [camects, setCamects] = useState(null);
    const [davantis, setDavantis] = useState(null);
    const [liveViewCameras, setLiveViewCameras] = useState(null);

    const [showSuccess, setShowSuccess] = useState(false)
    const [showFail, setShowFail] = useState(false)
    const [failMessage, setFailMessage] = useState("")


    const fetchVirtualSources = () => {

        const getSensors = async () => {
            const response = await getVirtualRelationshipsAPI(apiData, DeviceUUID)
            console.log(response[0]);
            setSigfoxSensors(response[0]["sigfox"])
            setEfentoSensors(response[0]["efento"])
            setTeltonikaSensors(response[0]["teltonika"])
            // setTankSensors(response.data[0]["tek880"])
            setGateways(response[0]["gateways"])
        }

        const getCamects = async () => {
            return await getCamectsAPI(apiData, DeviceUUID)
        }

        const getDavantis = async () => {
            return await getDavantisesAPI(apiData, DeviceUUID)
        }

        const getTankSensors = async () => {
           const response = await getTankSensorsForSite(apiData, DeviceUUID, dispatch)
           console.log(response);
           if (response.success){
            setTankSensors(response.data)
           }
        }

        const GetIntegrations = async () => {
            const integrations = await getIntegrations(apiData, DeviceUUID, dispatch)
            setIntegrations(integrations)
        }

        const listLiveViewCameras = async () => {
            const response = await getLiveViewCameras(apiData, DeviceUUID)
            if (response.success){
                console.log(response.data);
                setLiveViewCameras(response.data)
            }
                  
        }

        getSensors();
        setCamects(getCamects());
        GetIntegrations();
        getTankSensors();
        if (device[1].liveViewEnabled == 1){
            listLiveViewCameras();
        } else {
            setLiveViewCameras([])
        }
        
        if (firmwareMajor >= 3) {
            setDavantis(getDavantis());
        }
    }

    const checkCamectSupport = async () => {
        const supportsCamect = await checkSiteConfig(apiData, device[1].id, dispatch)
        _setSupportsCamect(supportsCamect[0].supportsCamect)
    }

    // Resolve the site's "monitored by" arc ID into its name, so the CCTV integration selector
    // can gate the Webeye option to sites monitored by one of the Webeye arcs.
    const resolveMonitoredByName = async () => {
        const response = await listPartneredArcs(apiData, dispatch)
        const arc = response?.data?.find(arc => arc.id == device[1].monitoredBy)
        setMonitoredByName(arc?.name ?? null)
    }

    // Seed all state directly from the route loader's preloaded data (no network round trip).
    const applyPreloadedData = (data) => {
        setSigfoxSensors(data.virtualRelationshipsRes?.[0]?.["sigfox"] ?? null);
        setEfentoSensors(data.virtualRelationshipsRes?.[0]?.["efento"] ?? null);
        setTeltonikaSensors(data.virtualRelationshipsRes?.[0]?.["teltonika"] ?? null);
        setGateways(data.virtualRelationshipsRes?.[0]?.["gateways"] ?? null);
        setCamects(data.camectsRes ?? null);
        setTankSensors(data.tankSensorsRes?.success ? data.tankSensorsRes.data : null);
        setIntegrations(data.integrationsRes ?? null);
        setLiveViewCameras(data.liveViewEnabled ? (data.liveViewCamerasRes?.success ? data.liveViewCamerasRes.data : []) : []);
        if (firmwareMajor >= 3) {
            setDavantis(data.davantisRes ?? null);
        }
        _setSupportsCamect(data.supportsCamectRes?.[0]?.supportsCamect ?? 0);
    }

    // Fetch data on mount — seed from preload when available, otherwise fetch live
    // (fetchVirtualSources/checkCamectSupport stay available for any future refresh need).
    useEffect(() => {
        if (preloadedData) {
            applyPreloadedData(preloadedData);
        } else {
            checkCamectSupport();
            fetchVirtualSources();
        }
        resolveMonitoredByName();
    }, []);

    useEffect(() => {
    }, [sigfoxSensors, efentoSensors, gateways, davantis, integrations, liveViewCameras, tankSensors])

    const virtualInputsArray = (siteType == "ESP" || siteType == "AB" || siteType == "A") ? [1, 2, 3, 4, 21, 20, 16, 12] : [21, 20, 16, 12, 4, 3, 2, 1]
    const virtualInputs = inputs.filter(input => virtualInputsArray.includes(input.Pin));
    const lockPins = iglooLocks.map((lockOutputPin) => lockOutputPin.outputPin)
    const pinsAvailableToLink = outputs.filter(item => !lockPins.includes(item.Pin.toString()));
    const [showVirtualSource, setShowVirtualSource] = useState(null);
    const [camectDetails, setcamectDetails] = useState(null);

    //handle which camect form to show 
    const HandleSelectCamectModalForm = (AutomationID, camectDetails) => {
        if (camectDetails != null && camectDetails != undefined) {
            setShowVirtualSource(AutomationID);
            setcamectDetails(camectDetails)
        } else {
            setShowVirtualSource(AutomationID);
        }
    }

    const checkAvailableIntegrationPins = () => {
        const linkedIntegrationPinNumbers = integrations?.map(integration => integration.pin);
        const availablePins = outputs?.filter(output =>
            !linkedIntegrationPinNumbers?.includes(String(output.Pin))
        );

        return availablePins;
    };

    return (
        <>

         <Dialog
            header="Success"
            visible={showSuccess}
            style={{ width: "35vw" }}
            onHide={() => setShowSuccess(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{ color: "#6e6e6eff" }}>Action completed successfully</h3>
            <Lottie
                animationData={successAnim}
                loop={false}
                style={{ width: 250, height: 250, margin: "0px" }}
            />
            <br/>
            <Button label="Close" icon="pi pi-times" severity="primary" onClick={() => setShowSuccess(false)} />
            </div>
        </Dialog>

        <Dialog
            header="Error"
            visible={showFail}
            style={{ width: "30vw" }}
            onHide={() => setShowFail(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <Lottie
                animationData={failAnim}
                loop={false}
                style={{ width: 150, height: 150, margin: "0px" }}
            />
            <h3 style={{ color: "#6e6e6eff" }}>{failMessage}</h3>
            
            <br/>
            <Button label="Close" icon="pi pi-times" severity="primary" onClick={() => setShowFail(false)} />
            </div>
        </Dialog>

        <div>
            <Suspense fallback={
                <div className={classes["skeleton-grid"]}>
                    {[...Array(20)].map((_, i) => <DeviceCardSkeleton key={i} />)}
                </div>}>
                {}
                <Await resolve={Promise.all([camects, sigfoxSensors, efentoSensors, teltonikaSensors, tankSensors, gateways, davantis, integrations, liveViewCameras])}>
                    {([loadedCamects, loadedSigFoxSensors, loadedEfentoSensors, loadedTeltonikas, loadedTankSensors, loadedGateways, loadedDavantis, loadedIntegrations, loadedLiveViewCameras]) => (
                        <VirtualSourcesGrid
                            Camects={[loadedCamects]}
                            davantis={[loadedDavantis]}
                            sigfoxSensors={loadedSigFoxSensors}
                            efentoSensors={loadedEfentoSensors}
                            teltonikaSensors={loadedTeltonikas}
                            tankSensors={loadedTankSensors}
                            gateways={loadedGateways}
                            iglooLocks={iglooLocks}
                            integrations={loadedIntegrations}
                            liveViewCameras={loadedLiveViewCameras}
                            outputs={outputs}
                            inputs={inputs}
                            fetchVirtualSources={fetchVirtualSources}
                            HandleSelectCamectModalForm={HandleSelectCamectModalForm}
                            setShowVirtualSource={setShowVirtualSource}
                            firmware={DeviceDetails.firmware}
                            camectIntegrationType={DeviceDetails.camectIntegrationType}
                            setHasDeviceChanged={setHasDeviceChanged}
                            supportsCamect={_supportsCamect}
                            siteType={device[1].type}
                            supportsLiveView={device[1].liveViewEnabled == 1}
                            successVisible={showSuccess}
                            setSuccessVisible={setShowSuccess}
                            apiData={apiData}
                            siteUUID={DeviceUUID}
                        />
                    )}
                </Await>
            </Suspense>
            {showVirtualSource == 7 && <SelectCCTVIntegration HandleSelectCamectModalForm={HandleSelectCamectModalForm} firmwareMajor={firmwareMajor} firmwareMinor={firmwareMinor} supportsCamect={_supportsCamect} siteType={siteType} monitoredByName={monitoredByName} apiData={apiData} siteGroupID={siteGroupID} isRESUREGroup={isRESUREGroup} />}
            {showVirtualSource == 20 && <SelectSensor HandleSelectCamectModalForm={HandleSelectCamectModalForm} firmwareMajor={firmwareMajor} firmwareMinor={firmwareMinor} supportsCamect={_supportsCamect} siteType={siteType} apiData={apiData} siteGroupID={siteGroupID} isRESUREGroup={isRESUREGroup} />}

            {/* {showVirtualSource == 12 && <AiboxModalForm setShowVirtualSource={setShowVirtualSource} outputs={OutPutsPinNames} fetchVirtualSources={fetchVirtualSources}/>} */}
            {showVirtualSource == 12 && <AiboxForm setShowVirtualSource={setShowVirtualSource} outputs={checkAvailableIntegrationPins()} fetchVirtualSources={fetchVirtualSources} />}

            {showVirtualSource == 1 && <SigfoxModalForm setShowVirtualSource={setShowVirtualSource} inputs={virtualInputs} virtualType={"SIGFOX RE:SURE"} fetchVirtualSources={fetchVirtualSources} setShowSuccess={setShowSuccess} />}
            {showVirtualSource == 4 && <SigfoxModalForm setShowVirtualSource={setShowVirtualSource} inputs={virtualInputs} virtualType={"IOTA"} fetchVirtualSources={fetchVirtualSources} setShowSuccess={setShowSuccess} />}

            {showVirtualSource == 5 && <GatewayModalForm setShowVirtualSource={setShowVirtualSource} inputs={virtualInputs} virtualType={"Gateway"} fetchVirtualSources={fetchVirtualSources} setShowSuccess={setShowSuccess} />}

            {showVirtualSource == 6 && <LockModalForm setShowVirtualSource={setShowVirtualSource} outputs={pinsAvailableToLink} virtualType={"Padlock"} fetchVirtualSources={fetchVirtualSources} setHasDeviceChanged={setHasDeviceChanged} />}

            {showVirtualSource == 0 && <CamectModalForm setShowVirtualSource={setShowVirtualSource} title={"Add camect"} subTitle={"What are the camect details?"} placeholders={{ placeholder1: "IP/Domain Name...", placeholder2: "Enter Password" }} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 3 && <CamectModalForm setShowVirtualSource={setShowVirtualSource} title={"Edit camect"} subTitle={"What are the new details?"} placeholders={{ placeholder1: "IP/Domain Name...", placeholder2: "Enter Password" }} camect={camectDetails} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 8 && <CamectModalForm setShowVirtualSource={setShowVirtualSource} title={"Add Davantis"} subTitle={"What are the Davantis details?"} placeholders={{ placeholder1: "IP/Domain Name...", placeholder2: "Enter Password" }} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 9 && <HikvisionForm setShowVirtualSource={setShowVirtualSource} outputs={checkAvailableIntegrationPins()} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 10 && <CamectModalForm setShowVirtualSource={setShowVirtualSource} title={"Add Ajax"} subTitle={"What are the Ajax details?"} placeholders={{ placeholder1: "IP/Domain Name...", placeholder2: "Enter Password" }} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 11 && <CamectModalForm setShowVirtualSource={setShowVirtualSource} title={"Add Dahua"} subTitle={"What are the Dahua details?"} placeholders={{ placeholder1: "IP/Domain Name...", placeholder2: "Enter Password" }} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 13 && <LiveViewCameraForm setShowVirtualSource={setShowVirtualSource} fetchVirtualSources={fetchVirtualSources} setShowSuccess={setShowSuccess} setShowFail={setShowFail} setFailMessage={setFailMessage} />}
            {showVirtualSource == 14 && <AjaxForm setShowVirtualSource={setShowVirtualSource} outputs={checkAvailableIntegrationPins()} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 15 && <DahuaForm setShowVirtualSource={setShowVirtualSource} outputs={checkAvailableIntegrationPins()} fetchVirtualSources={fetchVirtualSources} />}
            {showVirtualSource == 16 && <NBIOTSensorForm setShowVirtualSource={setShowVirtualSource} inputs={virtualInputs} virtualType={"NB-IOT Sensor"} fetchVirtualSources={fetchVirtualSources} setShowSuccess={setShowSuccess}/>}
            {showVirtualSource == 17 && <BLESensorForm setShowVirtualSource={setShowVirtualSource} inputs={virtualInputs} virtualType={"BLE Sensor"} fetchVirtualSources={fetchVirtualSources} setShowSuccess={setShowSuccess}/>}
            {showVirtualSource == 21 && <FloodSensorForm setShowVirtualSource={setShowVirtualSource} inputs={virtualInputs} virtualType={"Flood Sensor"} fetchVirtualSources={fetchVirtualSources} setShowSuccess={setShowSuccess}/>}
            {showVirtualSource == 22 && <TankSensorForm setShowVirtualSource={setShowVirtualSource} inputs={virtualInputs} virtualType={"Tank Sensor"} fetchVirtualSources={fetchVirtualSources} setShowSuccess={setShowSuccess}/>}
            {showVirtualSource == 23 && <WebeyeForm setShowVirtualSource={setShowVirtualSource} outputs={outputs} fetchVirtualSources={fetchVirtualSources} setShowSuccess={setShowSuccess} />}
        </div>

        </>
    )
}

export default VirtualSources;
